(() => {
  const script = document.currentScript;
  const moneyFormat = script?.dataset.moneyFormat || '${{amount}}';
  const observedProductInfo = new WeakSet();
  const scheduledProductInfo = new WeakSet();

  function formatWithDelimiters(number, precision = 2, thousands = ',', decimal = '.') {
    if (number == null || Number.isNaN(Number(number))) return '0';

    const parts = (Number(number) / 100).toFixed(precision).split('.');
    const dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, `$1${thousands}`);
    return parts[1] ? `${dollars}${decimal}${parts[1]}` : dollars;
  }

  function formatMoney(cents) {
    const placeholder = moneyFormat.match(/{{\s*(\w+)\s*}}/)?.[1] || 'amount';
    let value;

    switch (placeholder) {
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_with_apostrophe_separator':
        value = formatWithDelimiters(cents, 2, "'", '.');
        break;
      default:
        value = formatWithDelimiters(cents, 2);
        break;
    }

    return moneyFormat.replace(/{{\s*\w+\s*}}/, value);
  }

  function getVariantId(productInfo) {
    return productInfo.querySelector('form[action*="/cart/add"] [name="id"]')?.value || '';
  }

  function getPriceData(block) {
    const dataElement = block.querySelector('[data-allure-variant-prices]');
    if (!dataElement?.textContent) return null;

    try {
      return JSON.parse(dataElement.textContent);
    } catch (error) {
      console.error('Unable to read Allure subscription price data:', error);
      return null;
    }
  }

  function setText(element, text) {
    if (element && element.textContent.trim() !== text) element.textContent = text;
  }

  function setDisplay(element, display) {
    if (!element || element.style.display === display) return;
    if (display) element.style.display = display;
    else element.style.removeProperty('display');
  }

  function syncOneTimePrice(productInfo) {
    const block = productInfo.querySelector('.allure-subscription-block');
    const selectedOption = block?.querySelector('input[name="allure_selling_plan_id"]:checked');
    if (!block || !selectedOption || selectedOption.value) return;

    const variantId = getVariantId(productInfo);
    const priceData = getPriceData(block);
    const price = Number(priceData?.prices?.[variantId]?.['']);
    const compareAtPrice = Number(priceData?.compare_at?.[variantId]);
    const priceElement = productInfo.querySelector('.price');
    const regularBlock = priceElement?.querySelector('.price__regular');
    const saleBlock = priceElement?.querySelector('.price__sale');
    if (!variantId || !Number.isFinite(price) || !priceElement || !regularBlock || !saleBlock) return;

    const regularPrice = regularBlock.querySelector('.price-item--regular');
    const salePrice = saleBlock.querySelector('.price-item--sale');
    const saleCompareAt = saleBlock.querySelector('s.price-item--regular');
    const isOnSale = Number.isFinite(compareAtPrice) && compareAtPrice > price;

    if (isOnSale) {
      priceElement.classList.add('price--on-sale');
      setText(salePrice, formatMoney(price));
      setText(saleCompareAt, formatMoney(compareAtPrice));
      setDisplay(regularBlock, 'none');
      setDisplay(saleBlock, '');
    } else {
      priceElement.classList.remove('price--on-sale');
      setText(regularPrice, formatMoney(price));
      setDisplay(regularBlock, '');
      setDisplay(saleBlock, 'none');
    }
  }

  function scheduleSync(productInfo) {
    if (!productInfo || scheduledProductInfo.has(productInfo)) return;
    scheduledProductInfo.add(productInfo);
    requestAnimationFrame(() => {
      scheduledProductInfo.delete(productInfo);
      syncOneTimePrice(productInfo);
    });
  }

  function observeProductInfo(productInfo) {
    if (!productInfo || observedProductInfo.has(productInfo)) return;
    const block = productInfo.querySelector('.allure-subscription-block');
    const priceElement = productInfo.querySelector('.price');
    if (!block || !priceElement) return;

    observedProductInfo.add(productInfo);
    scheduleSync(productInfo);

    const priceObserver = new MutationObserver(() => scheduleSync(productInfo));
    priceObserver.observe(priceElement, {
      attributes: true,
      childList: true,
      characterData: true,
      subtree: true,
    });
  }

  function observeAllProductInfo() {
    document.querySelectorAll('product-info').forEach(observeProductInfo);
  }

  document.addEventListener('change', (event) => {
    if (!event.target.matches('input[name="allure_selling_plan_id"], form[action*="/cart/add"] [name="id"]')) return;
    scheduleSync(event.target.closest('product-info'));
  });

  document.addEventListener('shopify:section:load', observeAllProductInfo);
  observeAllProductInfo();

  const pageObserver = new MutationObserver(observeAllProductInfo);
  pageObserver.observe(document.documentElement, { childList: true, subtree: true });
})();
